import { Box } from 'designSystem/components/Box'
import { Text } from 'designSystem/components/Text'
import React from 'react'

export type PageMetadataEvalCommentItemProps = {
  text: string
  byline: string | undefined
}

export function PageMetadataEvalCommentItem({
  text,
  byline,
}: PageMetadataEvalCommentItemProps): React.ReactElement {
  return (
    <Box
      display='flex'
      direction='column'
      gap='xs'
      width='full'
      padding='sm'
      radius='md'
      surface='muted'>
      {byline !== undefined ? (
        <Text variant='caption' color='muted'>
          {byline}
        </Text>
      ) : null}
      <Text variant='body'>{text}</Text>
    </Box>
  )
}
